import request from '@/utils/request';
/* 分类-列表 */
export function queryHuiLifeCategoryPageList(data) {
  return request({
    url: '/hui/life/category/queryHuiLifeCategoryPageList',
    method: 'POST',
    data
  });
}
/* 分类-删除 */
export function removeHuiLifeCategoryById(data) {
  return request({
    url: '/hui/life/category/removeHuiLifeCategoryById',
    method: 'POST',
    data
  });
}
/* 分类-修改状态 */
export function updateCategoryStatus(data) {
  return request({
    url: '/hui/life/category/updateCategoryStatus',
    method: 'POST',
    data
  });
}
/* 分类-新增 */
export function saveHuiLifeCategory(data) {
  return request({
    url: '/hui/life/category/saveHuiLifeCategory',
    method: 'POST',
    data
  });
}
/* 分类-编辑 */
export function updateHuiLifeCategory(data) {
  return request({
    url: '/hui/life/category/updateHuiLifeCategory',
    method: 'POST',
    data
  });
}
/* 分类-编辑时的信息 */
export function fetchHuiLifeCategoryDetailById(data) {
  return request({
    url: '/hui/life/category/fetchHuiLifeCategoryDetailById',
    method: 'POST',
    data
  });
}
/* 视频-获取慧生活分类列表 */
export function queryHuiLifeCategoryList(data) {
  return request({
    url: '/hui/life/category/queryHuiLifeCategoryList',
    method: 'POST',
    data
  });
}
/* 视频-列表 */
export function queryHuiLifeVideoPageList(data) {
  return request({
    url: '/hui/life/video/queryHuiLifeVideoPageList',
    method: 'POST',
    data
  });
}
/* 视频-增加 */
export function saveHuiLifeVideo(data) {
  return request({
    url: '/hui/life/video/saveHuiLifeVideo',
    method: 'POST',
    data
  });
}
/* 视频-修改 */
export function updateHuiLifeVideo(data) {
  return request({
    url: '/hui/life/video/updateHuiLifeVideo',
    method: 'POST',
    data
  });
}
/* 视频-修改的信息展示 */
export function fetchHuiLifeVideoDetailById(data) {
  return request({
    url: '/hui/life/video/fetchHuiLifeVideoDetailById',
    method: 'POST',
    data
  });
}
/* 视频-删除 */
export function removeHuiLifeVideoById(data) {
  return request({
    url: '/hui/life/video/removeHuiLifeVideoById',
    method: 'POST',
    data
  });
}
/* 视频-修改状态 */
export function updateVideoStatusById(data) {
  return request({
    url: '/hui/life/video/updateVideoStatusById',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/wisdomLife.js